export default __webpack_public_path__ + "static/media/tab_1.b562db0f.svg";